var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options, title: "Settings" } },
    [
      _c(
        "div",
        {
          staticClass: "mb-2 -mx-4 px-4 pt-4 border-t max-w-readable",
          class: { "border-b pb-4": _vm.$app.isErrorReportingAvailable }
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-between" },
            [
              _c("h3", { staticClass: "text-lg font-medium" }, [
                _vm._v(" Animations ")
              ]),
              _c("BaseToggle", {
                model: {
                  value: _vm.animations,
                  callback: function($$v) {
                    _vm.animations = $$v
                  },
                  expression: "animations"
                }
              })
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "text-sm text-gray-700 mt-2 leading-relaxed" },
            [
              _vm._v(
                " Animations are cool, but it's also cool to have a long battery life. If you want to save battery or your device is struggling to keep up, turn off the animations for a simpler experience. "
              )
            ]
          )
        ]
      ),
      _vm.$app.isErrorReportingAvailable
        ? _c("div", { staticClass: "mb-2 -mx-4 px-4 pt-4 max-w-readable" }, [
            _c(
              "div",
              { staticClass: "flex justify-between" },
              [
                _c("h3", { staticClass: "text-lg font-medium" }, [
                  _vm._v(" Error Reporting ")
                ]),
                _c("BaseToggle", {
                  model: {
                    value: _vm.errorReporting,
                    callback: function($$v) {
                      _vm.errorReporting = $$v
                    },
                    expression: "errorReporting"
                  }
                })
              ],
              1
            ),
            _c(
              "p",
              { staticClass: "text-sm text-gray-700 mt-2 leading-relaxed" },
              [
                _vm._v(
                  " If you are experiencing errors, you can turn on error reporting to send them to "
                ),
                _c("BaseLink", { attrs: { url: "https://sentry.io" } }, [
                  _vm._v(" Sentry ")
                ]),
                _vm._v(
                  ". Make sure that trackers are not blocking the reports. If things are so bad that you can't even get to this modal, you can always force error reporting appending "
                ),
                _c("code", [_vm._v("?error_reporting=on")]),
                _vm._v(" in the address bar. ")
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }